export const EXCEL_FILE_FORMATS = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];

export const CSV_FILE_FORMATS = ["text/csv"];

export const STRUCTURED_FILE_FORMATS = [
  ...EXCEL_FILE_FORMATS,
  ...CSV_FILE_FORMATS,
];

export const PDF_FILE_FORMAT = "application/pdf";
const WORD_DOCUMENT_FILE_FORMAT =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
const PPT_FILE_FORMAT = [
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
] as const;
const PPT_FILE_EXTENSIONS = ["ppt", "pptx"];
const PLAIN_TEXT_FILE_FORMAT = "text/plain";

export const UNSTRUCTURED_FILE_FORMATS = [
  PDF_FILE_FORMAT,
  WORD_DOCUMENT_FILE_FORMAT,
  PLAIN_TEXT_FILE_FORMAT,
  ...PPT_FILE_FORMAT,
];

export const ALL_DOCUMENT_FILE_FORMATS = [
  ...STRUCTURED_FILE_FORMATS,
  ...UNSTRUCTURED_FILE_FORMATS,
];

export const ALL_IMAGE_FILE_FORMATS = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/webp",
];

export const PAGE_LEVEL_CONTENT_TYPES = [
  ...PPT_FILE_EXTENSIONS,
  ...PPT_FILE_FORMAT,
];
